"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Consents_1 = require("./Consents");
const PaymentDetails_1 = require("./PaymentDetails");
const AmountOfSockets_1 = require("./enums/AmountOfSockets");
const ChargingStationColor_1 = require("./enums/ChargingStationColor");
const ChargingStationType_1 = require("./enums/ChargingStationType");
const ElectricityMainsValueType_1 = require("./enums/ElectricityMainsValueType");
const ground_type_1 = tslib_1.__importDefault(require("./enums/ground-type"));
const mount_type_1 = tslib_1.__importDefault(require("./enums/mount-type"));
class UpdateCase extends base_models_1.Serializable {
}
exports.default = UpdateCase;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates whether the customer has a smart meter',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'has_smart_meter' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "hasSmartMeter", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, base_models_1.Docs)({
        description: 'Indicates the estimated distance between the fusebox and the desired installationpoint',
        example: 20,
    }),
    (0, class_transformer_1.Expose)({ name: 'distance_fusebox_installation_point' }),
    tslib_1.__metadata("design:type", Number)
], UpdateCase.prototype, "distanceFuseboxInstallationPoint", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates whether the fusebox is attached to the outer wall',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'fuse_box_attached_to_outer_wall' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "fuseBoxAttachedToOuterWall", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(mount_type_1.default),
    (0, base_models_1.Docs)({
        description: 'Indicates whether the customer wants a pole or wall installation',
        example: 'Paalmontage',
    }),
    (0, class_transformer_1.Expose)({ name: 'pole_or_wall_installation' }),
    tslib_1.__metadata("design:type", String)
], UpdateCase.prototype, "poleOrWallInstallation", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates whether the crawl space is large and dry',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'dry_and_large_crawl_space' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "dryAndLargeCrawlSpace", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates whether the cables are desired to be under the ground',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'cables_under_ground' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "cablesUnderGround", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, base_models_1.Docs)({
        description: 'Indicates the estimated digging distance',
        example: 5,
    }),
    (0, class_transformer_1.Expose)({ name: 'digging_distance' }),
    tslib_1.__metadata("design:type", Number)
], UpdateCase.prototype, "diggingDistance", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsEnum)(ground_type_1.default, { each: true }),
    (0, base_models_1.Docs)({
        description: 'Indicates types of ground the installation provider would need to dig through',
        example: ['Klinker', 'Aarde / Zand'],
    }),
    (0, class_transformer_1.Expose)({ name: 'ground_type' }),
    tslib_1.__metadata("design:type", Array)
], UpdateCase.prototype, "groundType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(ChargingStationColor_1.ChargingStationColor),
    (0, base_models_1.Docs)({
        description: 'Indicates the color of the charging station',
        example: 'Wit',
    }),
    (0, class_transformer_1.Expose)({ name: 'color_charging_station' }),
    tslib_1.__metadata("design:type", String)
], UpdateCase.prototype, "colorChargingStation", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates the type of charging cable',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'fixed_or_modular_cable' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "fixedorModularCable", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNumberString)(),
    (0, base_models_1.Docs)({
        description: 'Indicates the amount of sockets',
        example: '2',
    }),
    (0, class_transformer_1.Expose)({ name: 'socket_charging_stations' }),
    tslib_1.__metadata("design:type", String)
], UpdateCase.prototype, "socketChargingStations", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates the need for a charge card',
        example: false,
    }),
    (0, class_transformer_1.Expose)({ name: 'charge_card' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "chargeCard", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates the need service subscription',
        example: false,
    }),
    (0, class_transformer_1.Expose)({ name: 'service_subscription' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "serviceSubscription", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(ChargingStationType_1.ChargingStationType),
    (0, base_models_1.Docs)({
        description: 'Indicates name of the charging station type',
        example: 's-line',
    }),
    (0, class_transformer_1.Expose)({ name: 'charging_station_name' }),
    tslib_1.__metadata("design:type", String)
], UpdateCase.prototype, "chargingStationName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)([
        ...Object.values(ElectricityMainsValueType_1.ElectricityMainsValueType),
        ...Object.values(ElectricityMainsValueType_1.ElectricityMainsValueTypeOld), // TODO: Remove once frontends are updated
    ]),
    (0, base_models_1.Docs)({
        description: 'Indicates the type of connection of the household',
        example: '1x25',
    }),
    (0, class_transformer_1.Expose)({ name: 'electricity_mains_value' }),
    tslib_1.__metadata("design:type", String)
], UpdateCase.prototype, "electricityMainsValue", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'Gives a description of the ground work',
        example: 'This is a description about the ground work',
    }),
    (0, class_transformer_1.Expose)({ name: 'groundwork_notes' }),
    tslib_1.__metadata("design:type", String)
], UpdateCase.prototype, "groundworkNotes", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'Gives a description of the intallation',
        example: 'This is a description about the intallation',
    }),
    (0, class_transformer_1.Expose)({ name: 'installation_notes' }),
    tslib_1.__metadata("design:type", String)
], UpdateCase.prototype, "installationNotes", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates if client wants a data subscription',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'data_subscription' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "dataSubscription", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates if client wants to use load balancing',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'load_balancing' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "loadBalancing", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates if the fusebox needs to be replaced',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'replace_fusebox' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "replaceFusebox", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        description: 'Indicates if the fusebox needs to be upgraded',
        example: true,
    }),
    (0, class_transformer_1.Expose)({ name: 'groupbox_upgrade' }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateCase.prototype, "groupboxUpgrade", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => PaymentDetails_1.LeadFormPaymentDetails),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {},
        description: 'payment details',
    }),
    (0, class_transformer_1.Expose)({ name: 'payment_details' }),
    tslib_1.__metadata("design:type", PaymentDetails_1.LeadFormPaymentDetails)
], UpdateCase.prototype, "paymentDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Consents_1.Consents),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: {
            acceptedCallFromAdvisor: true,
            acceptedPaymentConditions: false,
            acceptedTermsAndConditions: false,
            acceptedTariffRateChange: true,
        },
        description: 'Customer consents',
    }),
    tslib_1.__metadata("design:type", Consents_1.Consents)
], UpdateCase.prototype, "consents", void 0);
